import cloudflareAssets from "@/assets/cloudflareAssets";
import { CloudflareAsset, type Currencies } from "@/shared/common/enums";
import { Amount, CloudFlareImage } from "@/shared/components";
import { Divider } from "@ab.uitools/ui-library/components/Divider";
import { Image } from "@ab.uitools/ui-library/components/Image";
import { Text } from "@ab.uitools/ui-library/components/Text";

interface Props {
  index: number;
  className?: string;
  rounded?: boolean;
  isSelected: boolean;
  name?: string;
  currency?: Currencies;
  description?: string;
  expectedBalance?: number;
  number?: string;
}

export const AccountSelectOption = (
  {
    name,
    index,
    number,
    currency,
    isSelected,
    description,
    expectedBalance,
  }: Props) => {

  return (
    <div className="flexbox align-items--center">
      <div className="card-account-image flexbox rounded">
        <Image imagePath={cloudflareAssets.Account}/>
      </div>
      <div className="card-account-option-body flexbox flex-direction--column pl-10">
        {!!index && (
          <Divider
            color="light"
            type="primary"
            isHorizontal
          />
        )}
        <div className="full-width flexbox align-items--center justify-content--between py-8">
          <div className="full-width pt-8 pb-8">
            <div className="full-width flexbox justify-content--between align-items-center">
              <Text lineHeight="medium" size="standard" className="pr-8 truncate">
                {name || description}
              </Text>
              <div className="flexbox">
                <Amount
                  currency={currency}
                  amount={expectedBalance || 0}
                  weight="regular"
                  size="standard"
                  isShow
                />
                {isSelected && (
                  <CloudFlareImage
                    size="small"
                    className="ml-4"
                    path={CloudflareAsset.SelectedOption}
                  />
                )}
              </div>
            </div>
            <Text size="standard" className="pr-8">
              {number}
            </Text>
          </div>
        </div>
      </div>
    </div>
  );
};
